import { IconBrandGoogleBigQuery, IconWorld } from '@tabler/icons-react'

const icons = {
  IconBrandGoogleBigQuery,
  IconWorld
}


const explorer = {
  id: 'data-explorer',
  title: 'Data Explorer',
  type: 'group',
  needAdmin: false,
  children: [
    {
      id: 'explorer',
      title: 'Explorer',
      type: 'item',
      url: '/explorer',
      icon: icons.IconBrandGoogleBigQuery,
      breadcrumbs: false
    },
  ]
}

export default explorer
